import { render } from "./ApplicantsListView.vue?vue&type=template&id=a4ad8b74&scoped=true"
import script from "./ApplicantsListView.vue?vue&type=script&lang=js"
export * from "./ApplicantsListView.vue?vue&type=script&lang=js"

import "./ApplicantsListView.vue?vue&type=style&index=0&id=a4ad8b74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ad8b74"]])

export default __exports__